import React, { useState } from 'react';
import axios from 'axios';
import API_ENDPOINTS from '../ApiEndPoints';

const QuickAddTask = ({ onTaskCreated, variant = 'list' }) => {
    const [title, setTitle] = useState('');
    const [description, setDescription] = useState('');
    const [dateDue, setDateDue] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    const handleKeyDown = async (e) => {
        if (e.key === 'Enter' && title.trim()) {
            await handleSubmit();
        }
    };

    const handleSubmit = async () => {
        if (!title.trim()) return;
        setLoading(true);
        setError('');
        try {
            await axios.post(API_ENDPOINTS.tasks.store, {
                title: title,
                description: description,
                date_due: dateDue,
                // Defaulting to simple task
            });
            setTitle('');
            setDescription('');
            setDateDue('');
            if (onTaskCreated) onTaskCreated();
        } catch (error) {
            console.error("Failed to create task", error);
            setError(error?.response?.data?.error || 'Failed to create task.');
        } finally {
            setLoading(false);
        }
    };

    if (variant === 'table') {
        return (
            <>
                <tr className="task-quick-add-row">
                    <td style={{ width: '30%' }}>
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <input
                                type="text"
                                className="task-quick-input"
                                placeholder="Type task title..."
                                value={title}
                                onChange={(e) => setTitle(e.target.value)}
                                onKeyDown={handleKeyDown}
                                disabled={loading}
                                style={{ width: '100%', paddingLeft: '10px' }}
                            />
                        </div>
                    </td>
                    <td>
                        <input
                            type="text"
                            className="task-quick-input"
                            placeholder="Description (optional)"
                            value={description}
                            onChange={(e) => setDescription(e.target.value)}
                            disabled={loading}
                        />
                    </td>
                    <td style={{ color: '#94a3b8', fontSize: '12px' }}>Today</td>
                    <td>
                        <input
                            type="date"
                            className="form-control input-sm"
                            value={dateDue}
                            onChange={(e) => setDateDue(e.target.value)}
                            disabled={loading}
                            style={{ borderRadius: '8px' }}
                        />
                    </td>
                    <td style={{ textAlign: 'center' }}>
                        <div className="task-checkbox disabled"></div>
                    </td>
                    <td style={{ textAlign: 'center' }}>
                        <button
                            className="task-add-btn"
                            onClick={(e) => {
                                e.preventDefault();
                                handleSubmit();
                            }}
                            disabled={loading || !title.trim()}
                            style={{ opacity: loading || !title.trim() ? 0.6 : 1 }}
                        >
                            {loading ? <i className="fa fa-spinner fa-spin"></i> : <i className="fa fa-plus"></i>}
                        </button>
                    </td>
                </tr>
                {error && (
                    <tr>
                        <td colSpan="6" style={{ padding: '6px 12px', color: '#b91c1c', fontSize: '12px' }}>{error}</td>
                    </tr>
                )}
            </>
        );
    }

    return (
        <div className="list-group-item" style={{ backgroundColor: '#fff', padding: '5px 15px', borderBottom: '1px solid #ddd', borderLeft: '4px solid transparent' }}>
            <div className="row" style={{ display: 'flex', alignItems: 'center' }}>
                <div className="col-md-2">
                     <div className="text-success" style={{ padding: '2px 5px', marginBottom: 0, fontSize: '11px', textAlign: 'center', border: '1px solid #d6e9c6', fontWeight: 'bold', borderRadius: '4px' }}>
                        Add New Task <i className="fa fa-arrow-right"></i>
                     </div>
                </div>
                <div className="col-md-5">
                    <input
                        type="text"
                        className="form-control input-sm"
                        placeholder="Type task title..."
                        value={title}
                        onChange={(e) => setTitle(e.target.value)}
                        onKeyDown={handleKeyDown}
                        disabled={loading}
                        style={{ border: 'none', boxShadow: 'none', paddingLeft: 0 }}
                    />
                </div>
                <div className="col-md-2">
                    {/* Spacer for Created column */}
                </div>
                <div className="col-md-2">
                     <input
                        type="date"
                        className="form-control input-sm"
                        value={dateDue}
                        onChange={(e) => setDateDue(e.target.value)}
                        disabled={loading}
                        style={{ border: 'none', boxShadow: 'none', padding: 0, height: '30px' }}
                    />
                </div>
                <div className="col-md-1">
                    <button
                        className="btn btn-success btn-xs pull-right"
                        onClick={handleSubmit}
                        disabled={loading || !title.trim()}
                        title="Add Task"
                    >
                        {loading ? <i className="fa fa-spinner fa-spin"></i> : <i className="fa fa-plus"></i>}
                    </button>
                </div>
            </div>
            {error && (
                <div style={{ marginTop: '6px', color: '#b91c1c', fontSize: '12px' }}>{error}</div>
            )}
        </div>
    );
};

export default QuickAddTask;
